export default function LogoMain() {
  return <img src="/logo-b-bora.png" alt="Bora Tecnologia" width="36" height="36" style={{ display: 'block' }} />;
}
